import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {AgendaCalendarModel} from '../../../api/entity/agendaCalendar.model';



@Injectable({providedIn: 'root'})
export class AgendaCalendarRepository extends AbstractRepositoryV2<AgendaCalendarModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('AgendaCalendar', serviceElementsFactory, injector);
    }
}
